module.exports = __webpack_public_path__ + "static/media/Home-Shape.b7a4288e.svg";